import { ChangeDetectorRef, Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Location } from '@angular/common';
import * as XLSX from 'xlsx/xlsx.js';
import { XlmapperDialogComponent } from './xlmapper-dialog/xlmapper-dialog.component';
import { MatStepper } from '@angular/material/stepper';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { FormControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { LeadSourceService } from 'src/app/services/lead-source.service';
import { Observable, Subscription, Subject } from 'rxjs';
import { TIMEZONE_ZONES, TimezoneOption } from 'src/app/shared/utils/timezone-zones.constant';
import { filter, takeUntil, timeout } from 'rxjs/operators';

import { Router, NavigationEnd } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';


import { XlMapperService } from 'src/app/services/xl-mapper.service';
import { Constant } from 'src/app/constant/constant';
import { SequencesService } from 'src/app/services/sequences.service';
import { CommonService } from 'src/app/services/common.service';
import { ResourceAccess } from 'src/app/shared/utils/calsoft-validators';

@Component({
  selector: 'calsoft-xl-mapper',
  templateUrl: './xl-mapper.component.html',
  styleUrls: ['./xl-mapper.component.scss']
})
export class XlMapperComponent implements OnInit, OnDestroy {
  sanitizedUrl = '';

  currentPath = '';

  filelist: any;
  arrayBuffer: any;
  file: any;

  text: string;

  selectedFile: File | null = null;
  invalidFileFormat: boolean = false;

  mapperKeys: string[] = [];

  @Input() title: string;

  @Input() type: any;

  @Input() serviceUrl: any;

  @Input() url: any;

  @Input() urlNew: any;

  @Input() enableSequences: any = 0;

  secondFormGroup: UntypedFormGroup;

  isLinear = false;

  orientation: string;

  firstFormGroup: UntypedFormGroup;
  failedRecords: any;
  showFailedRecords: boolean = false;
  successRecords: any[] = [];
  showSuccessRecords: boolean = false;
  isUploading: boolean = false;
  // Dynamic column headers for failed records table
  columns: string[] = [];
  successColumns: string[] = [];
  xlUploadLimits: any;

  frontendFailedRecords: any[] = [];
  isProcessing: boolean = false;
  successCount: number = 0;
  failedCount: number = 0;
  progressMessage: string = '';
  isCompleted: boolean = false;

  constructor(
    private dialog: MatDialog,
    public loc: Location,
    private _formBuilder: UntypedFormBuilder,
    private leadSourceService: LeadSourceService,
    private router: Router,
    private snackBar: MatSnackBar,
    private xlMapperService: XlMapperService,
    private sequencesService: SequencesService,
    private commonService: CommonService,
    private cdr: ChangeDetectorRef,
  ) {

    this.currentPath = this.router.url || '';
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  textNew: any;


  ngOnInit() {

    console.log(this.enableSequences);


    this.orientation = "horizontal";

    this.text = 'Submit';

    this.textNew = 'Upload';

    this.title = 'Xl Mapper';

    this.initForm();

    this.getResource();

    this.getAllAttributeList();

    this.attributeYFilter();

    this.typeSequncesYFilter();
    this.typeidSequnceYFilter();

    this.secondFormGroup = this._formBuilder.group({
      status: ['', Validators.required]
    });



    this.filterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.filterStatus();
    });

    this.filteredStatus = this.zone.slice();
  }


  getResource() {


    this.commonService
      .getAllAccessForResource(ResourceAccess.LEAD)
      .subscribe((data: any) => {

        if (!data.read) {
          this.router.navigate(['/unauthorized']);
        } else {

          if (data.restriction.length > 0) {
            if (this.router.url.includes('/lead')) {
              this.xlUploadLimits = data.restriction[0].xlUploadLimits;
            } else {
              this.xlUploadLimits = "5000"
            }
          } else {
            this.xlUploadLimits = 0;
          }
        }
      });
  }


  addfile(event: any) {
    this.file = event.target.files[0];
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.file);

    fileReader.onload = () => {
      this.arrayBuffer = fileReader.result;
      const data = new Uint8Array(this.arrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });
      const first_sheet_name = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[first_sheet_name];

      // Use raw array to preserve values and then normalize dates
      const raw: any[][] = (XLSX.utils.sheet_to_json(worksheet, { header: 1, raw: true }) as any[][]) || [];
      const headers: any[] = (raw[0] || []) as any[];
      const rows: any[][] = raw.slice(1) as any[][];

      const filelist = rows.map(row => {
        const rowData: any = {};
        headers.forEach((header: any, index: number) => {
          let cell = row[index];
          if (cell != null && this.isDateHeader(String(header)) && typeof cell === 'number') {
            cell = this.excelSerialToJSDate(cell);
          }
          rowData[header] = cell;
        });
        return rowData;
      });

      this.filelist = filelist;
      if (this.filelist.length > 0) {
        this.mapperKeys = Object.keys(this.filelist[0]);
      }
      console.log('Extracted Titles:', this.mapperKeys);
    }
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (!file) return;

    const allowedExtensions = ['.csv', '.xlsx', '.xls'];
    const fileName = file.name.toLowerCase();
    const isValid = allowedExtensions.some(ext => fileName.endsWith(ext));

    if (!isValid) {
      this.invalidFileFormat = true;
      this.selectedFile = null;
      // Reset the input so the same invalid file can trigger change again
      event.target.value = '';
      return;
    }

    this.invalidFileFormat = false;
    this.selectedFile = file;
  }

  removeFile(): void {
    this.selectedFile = null;
    this.invalidFileFormat = false;
  }

  formatFileSize(bytes: number): string {
    if (!bytes) return '0 Bytes';
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  fileUpload = false;

  uploadFile(): void {
    if (!this.selectedFile) {
      alert("Please select a file first.");
      return;
    }

    this.isUploading = true;

    setTimeout(() => {
      const fileName = this.selectedFile.name.toLowerCase();
      const isCsv = fileName.endsWith('.csv');

      const fileReader = new FileReader();

      fileReader.readAsArrayBuffer(this.selectedFile);

      fileReader.onload = (e: any) => {
        try {
          this.arrayBuffer = e.target.result;
          const data = new Uint8Array(this.arrayBuffer);
          const workbook = XLSX.read(data, { type: "array" });

          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          // Get raw data as 2D array
          const rawData: any[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          const headers: any[] = (rawData[0] || []) as any[];
          const rows: any[][] = (rawData.slice(1) as any[][]).filter(row =>
            row && row.some(cell => cell != null && String(cell).trim() !== '')
          );

          // Normalize each row into an object using headers
          const filelist = rows.map(row => {
            const rowData: any = {};
            headers.forEach((header: any, index: number) => {
              let cell = row[index];
              // If header suggests a date or cell is a Date / numeric Excel serial, convert it
              if (cell != null && cell !== '') {
                if (cell instanceof Date) {
                  cell = this.formatDate(cell);
                } else if (
                  (typeof cell === 'number' || (typeof cell === 'string' && /^\d{5}(\.\d+)?$/.test(String(cell).trim()))) &&
                  this.isDateHeader(String(header))
                ) {
                  cell = this.excelSerialToJSDate(Number(cell));
                }
              }
              rowData[header] = cell != null ? cell : ''; // fill missing values with ''
            });
            return rowData;
          });

          this.filelist = filelist;

          // Check upload limit
          if (this.xlUploadLimits > 0 && this.filelist.length > this.xlUploadLimits) {
            this.snackBar.open(`Upload limit exceeded. You can upload maximum ${this.xlUploadLimits} records at a time.`, '×', {
              panelClass: 'error',
              verticalPosition: 'bottom',
              duration: 3000
            });
            this.filelist = [];
            this.isUploading = false;
            this.cdr.detectChanges();
            return;
          }

          // Save all headers (even if values are missing in first row)
          this.mapperKeys = headers.filter(h => !!h && typeof h === 'string');

          this.populateSourceMapperFromKeys(this.mapperKeys);

          setTimeout(() => {
            this.fileUpload = true;
            this.secondFormGroup.get('status')?.setValue('uploaded');
            this.isUploading = false;
            this.cdr.detectChanges();
          });

          console.log("Extracted Headers:", this.mapperKeys);
        } catch (err) {
          console.error("File processing error:", err);
          this.isUploading = false;
          this.cdr.detectChanges();
          this.snackBar.open("Error processing file. Please ensure it is a valid Excel or CSV file.", "×", {
            panelClass: 'error',
            duration: 3000
          });
        }
      };

      fileReader.onerror = () => {
        this.isUploading = false;
        this.cdr.detectChanges();
        this.snackBar.open("Error reading file.", "×", {
          panelClass: 'error',
          duration: 3000
        });
      };
    }, 50);
  }

  // Helper to detect if a header likely represents a date field
  private isDateHeader(header: string): boolean {
    if (!header) return false;
    const h = header.toLowerCase().replace(/[^a-z0-9]/g, '');
    return (
      h.includes('date') ||
      h.includes('created') ||
      h.includes('dob') ||
      h.includes('time') ||
      h.includes('timestamp') ||
      h.includes('call') ||
      h.includes('followup') ||
      h.includes('due') ||
      h.includes('birth') ||
      h.includes('schedule') ||
      h.includes('start') ||
      h.includes('end') ||
      h.includes('update')
    );
  }

  // Convert an Excel serial date number to a formatted date string (dd-MM-yyyy)
  private excelSerialToJSDate(serial: number): string {
    try {
      // Try using XLSX.SSF.parse_date_code if available
      if (XLSX && XLSX.SSF && XLSX.SSF.parse_date_code) {
        const parsed = XLSX.SSF.parse_date_code(serial);
        if (parsed && parsed.y) {
          const pad = (n: number) => (n < 10 ? '0' + n : n);
          return `${pad(parsed.d)}-${pad(parsed.m)}-${parsed.y}`;
        }
      }

      // Fallback conversion using Excel epoch
      const utc_days = Math.floor(serial - 25569);
      const utc_value = utc_days * 86400;
      const date_info = new Date(utc_value * 1000);
      const pad = (n: number) => (n < 10 ? '0' + n : n);
      return `${pad(date_info.getUTCDate())}-${pad(date_info.getUTCMonth() + 1)}-${date_info.getUTCFullYear()}`;
    } catch (e) {
      return String(serial);
    }
  }

  private formatDate(d: Date): string {
    if (!d || isNaN(d.getTime())) return '';
    const pad = (n: number) => (n < 10 ? '0' + n : n);
    return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`;
  }


  back() {
    this.loc.back();
  }

  openDialog() {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(XlmapperDialogComponent, {
        width: '790px',
        disableClose: true,
        data: this.mapperKeys
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {


      });

    }
    else {
      let dialogRef = this.dialog.open(XlmapperDialogComponent, {
        minWidth: '100vw', height: '100vh',
        data: this.mapperKeys
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {


      });
    }
  }

  goToStep3(stepper: MatStepper) {
    if (this.secondFormGroup.valid) {
      stepper.next();
    } else {
      this.secondFormGroup.markAllAsTouched();
    }
  }


  initForm() {
    this.firstFormGroup = this._formBuilder.group({
      id: [0],
      name: [''],
      TimeZone: [''],
      sequenceNo: [''],
      sourceMapper: this._formBuilder.array([
        this.initSourceMapper()
      ]),



    });
  }

  initSourceMapper(): UntypedFormGroup {
    return this._formBuilder.group({
      sourceMapperId: [''],
      sourceId: [''],
      formFields: [''],
      fieldMapper: [''],
      type: [0],
      isActive: [0],
    });
  }

  addOption() {

    (<UntypedFormArray>this.firstFormGroup.get('sourceMapper')).push(
      this.initSourceMapper()
    );

  }


  populateSourceMapperFromKeys(keys: string[]) {
    const control = <UntypedFormArray>this.firstFormGroup.get('sourceMapper');
    control.clear();

    keys.forEach(key => {
      control.push(this._formBuilder.group({
        sourceMapperId: [''],
        sourceId: [''],
        formFields: [''],
        fieldMapper: [key],
        type: [0],
        isActive: [1],
      }));
    });
  }

  removeOption(i) {
    (<UntypedFormArray>this.firstFormGroup.get('sourceMapper')).removeAt(i);
  }


  //attribute
  attributeList: any;
  attributeTypeList: any = [];
  filteredAttributeTypeList: any = [];
  attributeControl: UntypedFormControl = new UntypedFormControl();
  attributeFilterControl: UntypedFormControl = new UntypedFormControl();

  protected _onDestroy = new Subject<void>();

  getAllAttributeList() {

    console.log("type", this.type);


    this.leadSourceService.getDropDown(this.type).subscribe(
      (data: any[]) => {
        this.attributeList = data.filter(item => item.attributeCode !== 'Tags' && item.attributeCode !== 'TagId');

        this.attributeList.push({ "attributeCode": "parentId", "frontendLabel": "Parent Id" });

        if (this.router.url.includes("lead/xlMapper")) {
          let object = {
            "attributeCode": "createdAt",
            "frontendLabel": "Created Date"

          }

          this.attributeList.push(object);


          let object1 = {
            "attributeCode": "updateAt",
            "frontendLabel": "Updated Date"

          }

          this.attributeList.push(object1);
        }


        this.attributeTypeList = [...this.attributeList];
        this.filteredAttributeTypeList = [...this.attributeTypeList];


      }
    )

    this.attributeYFilter();

  }


  getAllAttribute() {
    this.filteredAttributeTypeList = this.attributeTypeList;
  }

  attributeYFilter() {
    this.attributeFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.attributeFilter();
      });
  }

  protected attributeFilter() {
    if (!this.attributeList) {
      return;
    }
    // get the search keyword
    let search = this.attributeFilterControl.value;
    if (!search) {
      this.filteredAttributeTypeList = this.attributeTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredAttributeTypeList = this.attributeTypeList.filter(Attribute => Attribute['frontendLabel'].toLowerCase().indexOf(search) > -1)
  }

  goToStep(stepper: MatStepper) {
    if (this.firstFormGroup.valid) {
      stepper.next();

      const dataStepIndex = +this.enableSequences === 1 ? 3 : 2;
      if (stepper.selectedIndex === dataStepIndex) {
        this.submit();
      }
    } else {
      this.firstFormGroup.markAllAsTouched();
    }
  }

  finalUpload(stepper: MatStepper) {
    if (this.isUploading) return;

    const invalidRows = this.mappedPreview.filter(row => row.isValid === false);
    const validRows = this.mappedPreview.filter(row => row.isValid !== false);

    if (validRows.length === 0) {
      this.snackBar.open(`No valid records to upload. Please fix unacceptable leads.`, '×', {
        panelClass: 'error',
        verticalPosition: 'bottom',
        duration: 3000
      });
      return;
    }

    this.frontendFailedRecords = invalidRows.map(row => {
      return { ...row, Message: row.errorMessage || 'Invalid Record' };
    });

    this.failedRecords = [...this.frontendFailedRecords];
    this.failedCount = this.failedRecords.length;
    if (this.failedRecords && this.failedRecords.length > 0) {
      const desired = ['Name', 'Email', 'PhoneNumber', 'Message', 'createdAt'];
      const firstRecord = this.failedRecords[0] || {};
      this.columns = desired.filter(k => k in firstRecord);
      this.showFailedRecords = true;
    }

    this.isUploading = true;
    this.textNew = "Processing";

    this.xlMapperService[this.serviceUrl](validRows)
      .pipe(timeout(180000)) // 3-minute timeout
      .subscribe(
        (response) => {
          this.isUploading = false;
          this.textNew = "Upload";

          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            const notificationId = response['data'];
            if (notificationId) {
              this.snackBar.open("Import started in background. Processing...", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
              this.pollImportStatus(notificationId);
            } else {
              this.isCompleted = true;
              this.snackBar.open(response['status_message'], '×', {
                panelClass: 'success',
                verticalPosition: 'bottom',
                duration: 5000
              });
            }
            stepper.next();
          } else {
            this.snackBar.open(response['status_message'], '×', {
              panelClass: 'error',
              verticalPosition: 'bottom',
              duration: 5000
            });
          }
        },
        (err) => {
          this.isUploading = false;
          this.textNew = "Upload";
          this.isCompleted = true;
          this.failedCount = this.failedRecords ? this.failedRecords.length : 0;

          this.snackBar.open("Data will Added At Backend it will sync automatically", '×', {
            panelClass: 'success',
            verticalPosition: 'bottom',
            duration: 5000
          });
          stepper.next();
        }
      );
  }

  pollImportStatus(notificationId: any) {
    this.isProcessing = true;
    this.isCompleted = false;
    this.progressMessage = 'Processing...';
    const interval = setInterval(() => {
      this.xlMapperService.getNotificationStatus(notificationId).subscribe(
        (res: any) => {
          if (res) {
            this.progressMessage = res.message || 'Processing...';
            if (res.status === 'Completed' || res.status === 'Failed') {
              clearInterval(interval);
              this.isProcessing = false;
              this.isCompleted = true;

              let backendFailed = [];
              if (res.data) {
                try {
                  const dataObj = JSON.parse(res.data);
                  const successList = dataObj['Sucess'] || [];
                  backendFailed = dataObj['Failed'] || [];
                  this.successCount = successList.length;
                  this.successRecords = successList;
                } catch (e) {
                  this.successCount = 0;
                  this.successRecords = [];
                }
              } else {
                this.successCount = 0;
                this.successRecords = [];
              }

              this.failedRecords = [...this.frontendFailedRecords, ...backendFailed];
              this.failedCount = this.failedRecords.length;

              if (this.failedRecords && this.failedRecords.length > 0) {
                const desired = ['Name', 'Email', 'PhoneNumber', 'Message', 'createdAt'];
                const firstRecord = this.failedRecords[0] || {};
                this.columns = desired.filter(k => k in firstRecord || k === 'Message');
                this.showFailedRecords = true;
              }

              if (this.successRecords && this.successRecords.length > 0) {
                const desired = ['Name', 'Email', 'PhoneNumber', 'createdAt'];
                const firstRecord = this.successRecords[0] || {};
                this.successColumns = desired.filter(k => k in firstRecord);
                this.showSuccessRecords = true;
              }

              const totalCount = this.successCount + this.failedCount;
              const toastMessage = `Lead import completed. Total: ${totalCount}, Imported: ${this.successCount}, Failed: ${this.failedCount}.`;

              this.snackBar.open(toastMessage, '×', {
                panelClass: res.status === 'Completed' ? 'success' : 'error',
                verticalPosition: 'bottom',
                duration: 5000
              });
            }
          }
        },
        error => {
          clearInterval(interval);
          this.isProcessing = false;
          this.isCompleted = true;
          this.failedCount = this.failedRecords ? this.failedRecords.length : 0;
          this.snackBar.open("Failed to retrieve import status", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 5000 });
        }
      );
    }, 2000);
  }


  displayedFormFields: string[] = [];
  mappedPreview: any[] = [];
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.dataSource.paginator = mp;
  }

  submit(): void {
    if (this.firstFormGroup.valid) {
      this.text = 'Processing';

      setTimeout(() => {
        const formData = this.firstFormGroup.value;

        this.mappedPreview = this.filelist.map((row) => {
          const mappedRow: any = {};
          formData.sourceMapper.forEach((map) => {
            if (map.fieldMapper && map.formFields) {
              let val = row[map.fieldMapper] != null ? row[map.fieldMapper] : '';
              if (val !== '' && val != null) {
                if (val instanceof Date) {
                  val = this.formatDate(val);
                } else if (
                  (typeof val === 'number' || (typeof val === 'string' && /^\d{5}(\.\d+)?$/.test(String(val).trim()))) &&
                  (this.isDateHeader(String(map.fieldMapper)) || this.isDateHeader(String(map.formFields)))
                ) {
                  val = this.excelSerialToJSDate(Number(val));
                }
              }
              mappedRow[map.formFields] = val;
            }
          });

          if (this.enableSequences == 1) {
            mappedRow['TimeZone'] = formData.TimeZone;
            mappedRow['sequenceNo'] = formData.sequenceNo;
          }

          return mappedRow;
        }).filter(row =>
          Object.values(row).some(value => value !== '' && value != null)
        );

        this.mappedPreview.forEach(row => this.validateRow(row));

        this.displayedFormFields = [
          ...formData.sourceMapper
            .filter(map => map.formFields)
            .map(map => map.formFields),
          ...(this.enableSequences == 1 ? ['TimeZone', 'sequenceNo'] : [])
        ];

        this.dataSource.data = this.mappedPreview;

        this.text = 'Submit';
        this.cdr.detectChanges();
      }, 500);

    } else {
      this.firstFormGroup.markAllAsTouched();
    }
  }


  deleteRow(row: any): void {
    const index = this.mappedPreview.indexOf(row);
    if (index !== -1) {
      this.mappedPreview.splice(index, 1);
      this.mappedPreview = [...this.mappedPreview];
      this.dataSource.data = this.mappedPreview;
      this.cdr.detectChanges();
    }
  }

  openEditDialog(row: any, template: any) {
    const index = this.mappedPreview.indexOf(row);
    this.dialog.open(template, {
      width: '500px',
      maxWidth: '90vw',
      panelClass: 'custom-modern-dialog',
      data: { originalRow: row, editingRow: { ...row }, rowIndex: index }
    });
  }

  saveEdit(data: any) {
    if (data && data.editingRow) {
      let targetRow = data.originalRow;
      if (!targetRow && data.rowIndex != null && data.rowIndex >= 0) {
        targetRow = this.mappedPreview[data.rowIndex];
      }
      if (targetRow) {
        Object.assign(targetRow, data.editingRow);
        this.validateRow(targetRow);
        let index = this.mappedPreview.indexOf(targetRow);
        if (index === -1 && data.rowIndex != null && data.rowIndex >= 0) {
          index = data.rowIndex;
        }
        if (index !== -1) {
          this.mappedPreview[index] = targetRow;
        }
      }
      this.mappedPreview = [...this.mappedPreview];
      this.dataSource.data = this.mappedPreview;
      this.cdr.detectChanges();
    }
    this.dialog.closeAll();
  }

  validateRow(row: any) {
    row.isValid = true;
    row.errorMessage = '';

    const phoneKeys = Object.keys(row).filter(k => k.toLowerCase().includes('phone'));
    for (let key of phoneKeys) {
      if (row[key]) {
        const cleanedPhone = String(row[key]).replace(/[\s\-\(\)\+]/g, '');
        if (!/^\d+$/.test(cleanedPhone) || cleanedPhone.length < 5) {
          row.isValid = false;
          row.errorMessage = 'Invalid Phone';
          return;
        }
      }
    }

    const emailKeys = Object.keys(row).filter(k => k.toLowerCase().includes('email'));
    for (let key of emailKeys) {
      if (row[key]) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(String(row[key]))) {
          row.isValid = false;
          row.errorMessage = 'Invalid Email';
          return;
        }
      }
    }

    // Validate NumberOfEmployees — only exact matches against valid options are allowed.
    // Any value that doesn't match (e.g. "10-20", "210-1500", "21023343551500") is cleared to empty.
    const validEmployeeOptions = ['1-10', '11-50', '51-200', '201-500', '501-1000', '1001-5000', '5001-10000', '10000+'];
    const empKeys = Object.keys(row).filter(k => k.toLowerCase().includes('numberofemployees') || k.toLowerCase().includes('noofemployees') || k.toLowerCase() === 'numberofemployees');
    for (let key of empKeys) {
      if (row[key] && row[key] !== '') {
        const val = String(row[key]).trim();
        if (!validEmployeeOptions.includes(val)) {
          row[key] = ''; // clear invalid value — do not mark row as invalid
        }
      }
    }
  }

  goToProductPage() {
    this.router.navigate([this.urlNew])
  }

  isFieldAlreadySelected(attributeCode: string, currentIndex: number): boolean {
    const sourceMapper = this.firstFormGroup.get('sourceMapper').value;


    return sourceMapper.some((group, index) => {
      return index !== currentIndex && group.formFields === attributeCode;
    });
  }

  listOfAttributeSelected: any = [];

  selectedData(event, eavAttribute) {

    if (event.isUserInput != false) {
      if (event.source._selected) {
        this.listOfAttributeSelected.push(eavAttribute.attributeId);

      } else {
        let index = this.listOfAttributeSelected.findIndex(x => x == eavAttribute.attributeId)
        this.listOfAttributeSelected.splice(index, 1);

      }
    }

  }


  //sequences

  filteredSequencesdropdownTypeList: any;

  public typeYSequencesFilterControl: UntypedFormControl = new UntypedFormControl();

  dropdownSequencesTypeList: any;
  sequencesList: any;

  sequences = new FormControl('');

  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();


  typeSequncesYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeidSequnceYFilter();
      });
  }

  protected typeidSequnceYFilter() {
    let search = this.typeYFilterControl.value;
    let searchTerm = search && search.trim() !== '' ? 'sequenceName:*' + search.trim() + '*' : '';
    searchTerm = searchTerm.replace(/'/g, '');

    this.sequencesService.getSequencesBySearch(searchTerm, 0, 50, 'sequenceId,desc').subscribe(
      (res: any) => {
        if (res && res['content']) {
          this.filteredSequencesdropdownTypeList = res['content'];
        }
      },
      error => { }
    );
  }

  //zone

  filteredStatus: any[] = [];

  filterCtrl: UntypedFormControl = new UntypedFormControl();

  filterStatus(): void {
    const search = this.filterCtrl.value ? this.filterCtrl.value.toLowerCase() : '';

    this.filteredStatus = this.zone.filter(item =>
      item.value.toLowerCase().includes(search) ||
      item.label.toLowerCase().includes(search)
    );
  }

  zone: TimezoneOption[] = TIMEZONE_ZONES;

  // kept for reference — DO NOT use inline array below; use TIMEZONE_ZONES instead
  private _zone_unused: any = [

    {
      "value": "IST",
      "label": "IST - (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi"
    },
    {
      "value": "Dateline Standard Time",
      "label": "BIT - (GMT-12:00) International Date Line West"
    },
    {
      "value": "Samoa Standard Time",
      "label": "SMST - (GMT-11:00) Midway Island, Samoa"
    },
    {
      "value": "Hawaiian Standard Time",
      "label": "HAST - (GMT-10:00) Hawaii"
    },
    {
      "value": "Alaskan Standard Time",
      "label": "AK - (GMT-09:00) Alaska"
    },
    {
      "value": "Pacific Standard Time",
      "label": "PT - (GMT-08:00) Pacific Time (US and Canada), Tijuana"
    },
    {
      "value": "US Mountain Standard Time",
      "label": "MST - (GMT-07:00) Arizona"
    },
    {
      "value": "Mountain Standard Time (Mexico)",
      "label": "MSTM - (GMT-07:00) Chihuahua, La Paz, Mazatlan"
    },
    {
      "value": "Mountain Standard Time",
      "label": "MT - (GMT-07:00) Mountain Time (US and Canada)"
    },
    {
      "value": "Central Standard Time (Mexico)",
      "label": "CST - (GMT-06:00) Guadalajara, Mexico City, Monterrey"
    },
    {
      "value": "Central Standard Time",
      "label": "CT - (GMT-06:00) Central Time (US and Canada)"
    },
    {
      "value": "Central America Standard Time",
      "label": "CAST - (GMT-06:00) Central America"
    },
    {
      "value": "Canada Central Standard Time",
      "label": "CCST - (GMT-06:00) Saskatchewan"
    },
    {
      "value": "US Eastern Standard Time",
      "label": "EST - (GMT-05:00) Indiana (East)"
    },
    {
      "value": "SA Pacific Standard Time",
      "label": "SAPST - (GMT-05:00) Bogota, Lima, Quito"
    },
    {
      "value": "Eastern Standard Time",
      "label": "ET - (GMT-05:00) Eastern Time (US and Canada)"
    },
    {
      "value": "Central Brazilian Standard Time",
      "label": "CBST - (GMT-04:00) Manaus"
    },
    {
      "value": "SA Western Standard Time",
      "label": "SAWST - (GMT-04:00) Caracas, La Paz"
    },
    {
      "value": "Pacific SA Standard Time",
      "label": "PSAST - (GMT-04:00) Santiago"
    },
    {
      "value": "Atlantic Standard Time",
      "label": "AST - (GMT-04:00) Atlantic Time (Canada)"
    },
    {
      "value": "Newfoundland Standard Time",
      "label": "NST - (GMT-03:30) Newfoundland and Labrador"
    },
    {
      "value": "SA Eastern Standard Time",
      "label": "SAEST - (GMT-03:00) Buenos Aires, Georgetown"
    },
    {
      "value": "Greenland Standard Time",
      "label": "GNST - (GMT-03:00) Greenland"
    },
    {
      "value": "E. South America Standard Time",
      "label": "ESAST - (GMT-03:00) Brasilia"
    },
    {
      "value": "Mid-Atlantic Standard Time",
      "label": "UTC02 - (GMT-02:00) Mid-Atlantic"
    },
    {
      "value": "Cape Verde Standard Time",
      "label": "CVT - (GMT-01:00) Cape Verde Islands"
    },
    {
      "value": "Azores Standard Time",
      "label": "AZOST - (GMT-01:00) Azores"
    },
    {
      "value": "Greenwich Standard Time",
      "label": "GST - (GMT-00:00) Casablanca, Monrovia"
    },
    {
      "value": "GMT Standard Time",
      "label": "GMT - (GMT-00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London"
    },
    {
      "value": "W. Europe Standard Time",
      "label": "WET - (GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
    },
    {
      "value": "W. Central Africa Standard Time",
      "label": "ECT - (GMT+01:00) West Central Africa"
    },
    {
      "value": "Romance Standard Time",
      "label": "RST - (GMT+01:00) Brussels, Copenhagen, Madrid, Paris"
    },
    {
      "value": "Central European Standard Time",
      "label": "CEST - (GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
    },
    {
      "value": "Central Europe Standard Time",
      "label": "CET - (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
    },
    {
      "value": "Namibia Standard Time",
      "label": "NMST - (GMT+02:00) Windhoek"
    },
    {
      "value": "South Africa Standard Time",
      "label": "SAST - (GMT+02:00) Harare, Pretoria"
    },
    {
      "value": "Israel Standard Time",
      "label": "ISST - (GMT+02:00) Jerusalem"
    },
    {
      "value": "GTB Standard Time",
      "label": "GTBST - (GMT+02:00) Athens, Bucharest, Istanbul"
    },
    {
      "value": "FLE Standard Time",
      "label": "EET - (GMT+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius"
    },
    {
      "value": "Egypt Standard Time",
      "label": "EGST - (GMT+02:00) Cairo"
    },
    {
      "value": "E. Europe Standard Time",
      "label": "EEST - (GMT+02:00) Minsk"
    },
    {
      "value": "Russian Standard Time",
      "label": "MSK - (GMT+03:00) Moscow, St. Petersburg, Volgograd"
    },
    {
      "value": "E. Africa Standard Time",
      "label": "EAT - (GMT+03:00) Nairobi"
    },
    {
      "value": "Arabic Standard Time",
      "label": "ARST - (GMT+03:00) Baghdad"
    },
    {
      "value": "Arab Standard Time",
      "label": "ABST - (GMT+03:00) Kuwait, Riyadh"
    },
    {
      "value": "Iran Standard Time",
      "label": "IRST - (GMT+03:30) Tehran"
    },
    {
      "value": "Georgian Standard Time",
      "label": "GET - (GMT+04:00) Tblisi"
    },
    {
      "value": "Azerbaijan Standard Time",
      "label": "AZT - (GMT+04:00) Baku"
    },
    {
      "value": "Caucasus Standard Time",
      "label": "AMT - (GMT+04:00) Yerevan"
    },
    {
      "value": "Arabian Standard Time",
      "label": "ARBST - (GMT+04:00) Abu Dhabi, Muscat"
    },
    {
      "value": "Afghanistan Standard Time",
      "label": "AFT - (GMT+04:30) Kabul"
    },
    {
      "value": "Dateline Standard Time",
      "label": "BIT - (GMT-12:00) International Date Line West"
    },
    {
      "value": "Samoa Standard Time",
      "label": "SMST - (GMT-11:00) Midway Island, Samoa"
    },
    {
      "value": "Hawaiian Standard Time",
      "label": "HAST - (GMT-10:00) Hawaii"
    },
    {
      "value": "Alaskan Standard Time",
      "label": "AK - (GMT-09:00) Alaska"
    },
    {
      "value": "Pacific Standard Time",
      "label": "PT - (GMT-08:00) Pacific Time (US and Canada), Tijuana"
    },
    {
      "value": "US Mountain Standard Time",
      "label": "MST - (GMT-07:00) Arizona"
    },
    {
      "value": "Mountain Standard Time (Mexico)",
      "label": "MSTM - (GMT-07:00) Chihuahua, La Paz, Mazatlan"
    },
    {
      "value": "Mountain Standard Time",
      "label": "MT - (GMT-07:00) Mountain Time (US and Canada)"
    },
    {
      "value": "Central Standard Time (Mexico)",
      "label": "CST - (GMT-06:00) Guadalajara, Mexico City, Monterrey"
    },
    {
      "value": "Central Standard Time",
      "label": "CT - (GMT-06:00) Central Time (US and Canada)"
    },
    {
      "value": "Central America Standard Time",
      "label": "CAST - (GMT-06:00) Central America"
    },
    {
      "value": "Canada Central Standard Time",
      "label": "CCST - (GMT-06:00) Saskatchewan"
    },
    {
      "value": "US Eastern Standard Time",
      "label": "EST - (GMT-05:00) Indiana (East)"
    },
    {
      "value": "SA Pacific Standard Time",
      "label": "SAPST - (GMT-05:00) Bogota, Lima, Quito"
    },
    {
      "value": "Eastern Standard Time",
      "label": "ET - (GMT-05:00) Eastern Time (US and Canada)"
    },
    {
      "value": "Central Brazilian Standard Time",
      "label": "CBST - (GMT-04:00) Manaus"
    },
    {
      "value": "SA Western Standard Time",
      "label": "SAWST - (GMT-04:00) Caracas, La Paz"
    },
    {
      "value": "Pacific SA Standard Time",
      "label": "PSAST - (GMT-04:00) Santiago"
    },
    {
      "value": "Atlantic Standard Time",
      "label": "AST - (GMT-04:00) Atlantic Time (Canada)"
    },
    {
      "value": "Newfoundland Standard Time",
      "label": "NST - (GMT-03:30) Newfoundland and Labrador"
    },
    {
      "value": "SA Eastern Standard Time",
      "label": "SAEST - (GMT-03:00) Buenos Aires, Georgetown"
    },
    {
      "value": "Greenland Standard Time",
      "label": "GNST - (GMT-03:00) Greenland"
    },
    {
      "value": "E. South America Standard Time",
      "label": "ESAST - (GMT-03:00) Brasilia"
    },
    {
      "value": "Mid-Atlantic Standard Time",
      "label": "UTC02 - (GMT-02:00) Mid-Atlantic"
    },
    {
      "value": "Cape Verde Standard Time",
      "label": "CVT - (GMT-01:00) Cape Verde Islands"
    },
    {
      "value": "Azores Standard Time",
      "label": "AZOST - (GMT-01:00) Azores"
    },
    {
      "value": "Greenwich Standard Time",
      "label": "GST - (GMT-00:00) Casablanca, Monrovia"
    },
    {
      "value": "GMT Standard Time",
      "label": "GMT - (GMT-00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London"
    },
    {
      "value": "W. Europe Standard Time",
      "label": "WET - (GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
    },
    {
      "value": "W. Central Africa Standard Time",
      "label": "ECT - (GMT+01:00) West Central Africa"
    },
    {
      "value": "Romance Standard Time",
      "label": "RST - (GMT+01:00) Brussels, Copenhagen, Madrid, Paris"
    },
    {
      "value": "Central European Standard Time",
      "label": "CEST - (GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
    },
    {
      "value": "Central Europe Standard Time",
      "label": "CET - (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
    },
    {
      "value": "Namibia Standard Time",
      "label": "NMST - (GMT+02:00) Windhoek"
    },
    {
      "value": "South Africa Standard Time",
      "label": "SAST - (GMT+02:00) Harare, Pretoria"
    },
    {
      "value": "Israel Standard Time",
      "label": "ISST - (GMT+02:00) Jerusalem"
    },
    {
      "value": "GTB Standard Time",
      "label": "GTBST - (GMT+02:00) Athens, Bucharest, Istanbul"
    },
    {
      "value": "FLE Standard Time",
      "label": "EET - (GMT+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius"
    },
    {
      "value": "Egypt Standard Time",
      "label": "EGST - (GMT+02:00) Cairo"
    },
    {
      "value": "E. Europe Standard Time",
      "label": "EEST - (GMT+02:00) Minsk"
    },
    {
      "value": "Russian Standard Time",
      "label": "MSK - (GMT+03:00) Moscow, St. Petersburg, Volgograd"
    },
    {
      "value": "E. Africa Standard Time",
      "label": "EAT - (GMT+03:00) Nairobi"
    },
    {
      "value": "Arabic Standard Time",
      "label": "ARST - (GMT+03:00) Baghdad"
    },
    {
      "value": "Arab Standard Time",
      "label": "ABST - (GMT+03:00) Kuwait, Riyadh"
    },
    {
      "value": "Iran Standard Time",
      "label": "IRST - (GMT+03:30) Tehran"
    },
    {
      "value": "Georgian Standard Time",
      "label": "GET - (GMT+04:00) Tblisi"
    },
    {
      "value": "Azerbaijan Standard Time",
      "label": "AZT - (GMT+04:00) Baku"
    },
    {
      "value": "Caucasus Standard Time",
      "label": "AMT - (GMT+04:00) Yerevan"
    },
    {
      "value": "Arabian Standard Time",
      "label": "ARBST - (GMT+04:00) Abu Dhabi, Muscat"
    },
    {
      "value": "Afghanistan Standard Time",
      "label": "AFT - (GMT+04:30) Kabul"
    },
    {
      "value": "West Asia Standard Time",
      "label": "WAST - (GMT+05:00) Islamabad, Karachi, Tashkent"
    }

  ]

  downloadSampleTemplate() {
    if (!this.attributeList || this.attributeList.length === 0) {
      this.snackBar.open("No attributes found to generate template.", "×", { duration: 3000 });
      return;
    }
    const headers = this.attributeList.map(attr => attr.frontendLabel || attr.attributeCode);
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([headers]);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sample Template');
    XLSX.writeFile(wb, `${this.title || 'template'}_sample.xlsx`);
    this.snackBar.open("Sample template downloaded successfully", "×", {
      panelClass: 'success',
      duration: 3000
    });
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
